import script from "./sales_templates_edit.vue?vue&type=script&setup=true&lang=js"
export * from "./sales_templates_edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__